import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { Stack, Divider, Box } from "braid-design-system";
import { Section, Banner, Tagline, Price, isPositiveNumber, Expectations, CallToAction, Inclusions } from "../../layouts/GridLayout/GridLayout.mjs";
import { Image } from "../../elements/Image/Image.mjs";
import { grid1Image } from "./ColumnPanel.css.mjs";
const ColumnPanelGrid1 = ({
  product,
  isSelected,
  isLoading,
  onSelect
}) => {
  var _a, _b, _c, _d, _e, _f, _g;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    product.banner && /* @__PURE__ */ jsx(Section, { gridArea: "banner", children: /* @__PURE__ */ jsx(Banner, { type: product.banner.type, variant: product.banner.variant }) }),
    product.tagline && /* @__PURE__ */ jsx(Section, { gridArea: "title", children: /* @__PURE__ */ jsx(Stack, { space: "small", align: "center", children: product.tagline && /* @__PURE__ */ jsx(
      Tagline,
      {
        content: product.tagline.content,
        variant: product.tagline.variant
      }
    ) }) }),
    product.price.type !== "HiddenPrice" && /* @__PURE__ */ jsx(Section, { gridArea: "price", children: /* @__PURE__ */ jsxs(Stack, { space: "medium", align: "center", children: [
      /* @__PURE__ */ jsx(Divider, {}),
      /* @__PURE__ */ jsx(Price, { price: product.price, size: "xlarge" })
    ] }) }),
    isPositiveNumber((_a = product.expectations) == null ? void 0 : _a.count) && /* @__PURE__ */ jsx(Section, { gridArea: "expectations", children: /* @__PURE__ */ jsx(Stack, { space: "xxsmall", children: isPositiveNumber((_b = product.expectations) == null ? void 0 : _b.count) && /* @__PURE__ */ jsx(Expectations, { expectations: product.expectations }) }) }),
    (product == null ? void 0 : product.cta) && /* @__PURE__ */ jsx(Section, { gridArea: "cta", children: /* @__PURE__ */ jsx(Box, { height: "full", display: "flex", children: /* @__PURE__ */ jsx(
      CallToAction,
      {
        id: product.id,
        isSelected,
        isLoading,
        onClick: (intent) => onSelect(product.id, product.type, intent),
        url: (_c = product == null ? void 0 : product.cta) == null ? void 0 : _c.url,
        variant: (_d = product.cta) == null ? void 0 : _d.variant,
        content: (_e = product.title) == null ? void 0 : _e.content
      }
    ) }) }),
    product.inclusions && /* @__PURE__ */ jsx(Section, { gridArea: "inclusions", children: /* @__PURE__ */ jsx(Stack, { space: "medium", children: Boolean((_g = (_f = product.inclusions) == null ? void 0 : _f.content) == null ? void 0 : _g.length) && /* @__PURE__ */ jsx(Inclusions, { inclusions: product.inclusions }) }) }),
    product.image && /* @__PURE__ */ jsx(Section, { gridArea: "image", children: /* @__PURE__ */ jsx(Stack, { space: "none", align: "center", children: /* @__PURE__ */ jsx(Box, { className: grid1Image, children: /* @__PURE__ */ jsx(Image, { image: product.image }) }) }) })
  ] });
};
export {
  ColumnPanelGrid1
};
